import router from '@/router'

export const back = async fallbackLocation => {
  const { previousPath } = window.history.state

  if (previousPath) await router.back()
  else await router.replace(fallbackLocation || { name: 'Home' })
}
